/**
 * Session notice styling.
 *
 * Top centre, above everything, and it takes no pointer events: a line saying somebody left must
 * not be a place a shot can land on. The same bone white on near black as every other surface,
 * with the amber reserved for the edge, so it reads as the game talking rather than as part of the
 * HUD.
 */

import { injectCss } from '@/ui/cssInjector';

const CSS = `
.notices {
  position: fixed;
  top: calc(env(safe-area-inset-top, 0px) + 16px);
  left: 50%;
  z-index: 30;
  display: grid;
  gap: 8px;
  justify-items: center;
  translate: -50% 0;
  pointer-events: none;
  font: 500 14px/1.4 ui-monospace, "SF Mono", Menlo, Consolas, monospace;
  color: #f2ede3;
}

.notice {
  max-width: min(90vw, 52ch);
  padding: 10px 16px;
  border-left: 3px solid #e8b34a;
  border-radius: 0 4px 4px 0;
  background: rgba(11, 12, 14, 0.86);
  -webkit-backdrop-filter: blur(6px);
  backdrop-filter: blur(6px);
  animation: notice-in 200ms ease both;
}

@keyframes notice-in {
  from { opacity: 0; translate: 0 -6px; }
  to { opacity: 1; translate: 0 0; }
}

@media (prefers-reduced-motion: reduce) {
  .notice { animation: none; }
}
`;

export function injectSessionNoticeStyles(): () => void {
  return injectCss(CSS);
}
